<!-- 操作面板 -->
<template>
    <div v-if="componentsData.type == 30">
        <div class="status-panel bg-div" :style="panelStyle">
            <!-- 样式一 -->
            <div v-if="styleValue == '1'">
                <div v-if="title" class="panel-title" :style="titleStyle">
                    {{ title }}
                </div>
                <div
                    class="control-grid"
                    v-for="(item, index) in controlList"
                    :key="index"
                    :style="itemBgStyle(item)"
                >
                    <div>
                        <div class="mb6" :style="nameStyle(item)">
                            {{ item.btn_title }}
                        </div>
                        <div :style="descStyle(item)">
                            {{ item.btn_desc }}
                        </div>
                    </div>
                    <Button class="control-btn" :style="buttonStyle(item)">{{
                        item.btn_text
                    }}</Button>
                </div>
            </div>
            <!-- 样式二 -->
            <div v-else>
                <div class="control-name">表单名称</div>
                <div class="control-txt">姓名</div>
                <Input placeholder="请输入" class="mt6 mb12"></Input>
                <Button class="submit-btn">提交</Button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    computed: {
        // 安全获取内容配置，避免数据未加载时访问报错
        content() {
            return this.componentsData.content || {};
        },
        // 样式标识：1-样式一 2-样式二
        styleValue() {
            return this.content.style_value;
        },
        title() {
            return this.content.title;
        },
        controlList() {
            return Array.isArray(this.content.controlList)
                ? this.content.controlList
                : [];
        },
        // 面板整体样式（背景、边距、圆角），仅应用已配置字段
        panelStyle() {
            const content = this.content;
            const style = {};
            if (content.paddingData) {
                style.padding = `${content.paddingData.top}px ${content.paddingData.left}px`;
            }
            if (content.marginData) {
                style.margin = `${content.marginData.top}px ${content.marginData.left}px`;
            }
            if (content.radiusData) {
                style.borderRadius = `${content.radiusData.top}px ${content.radiusData.top}px ${content.radiusData.bottom}px ${content.radiusData.bottom}px`;
            }
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            if (content.bg_img && content.bg_img.picview && content.bg_value) {
                style.backgroundImage = `url(${content.bg_img.picview})`;
            }
            return style;
        },
        // 面板标题样式
        titleStyle() {
            const style = {};
            if (this.content.title_color) {
                style.color = this.content.title_color;
            }
            if (this.content.title_size) {
                style.fontSize = `${this.content.title_size}px`;
            }
            return style;
        },
    },
    methods: {
        // 单个操作项背景色
        itemBgStyle(item) {
            return { backgroundColor: item.bg_color };
        },
        // 操作标题颜色
        nameStyle(item) {
            return { color: item.btn_title_color };
        },
        // 操作说明颜色
        descStyle(item) {
            return { color: item.btn_desc_color };
        },
        // 操作按钮样式
        buttonStyle(item) {
            return {
                color: item.btn_text_color,
                backgroundColor: item.btn_color,
                borderColor: item.border_color,
            };
        },
    },
};
</script>

<style scoped>
.mt6 {
    margin-top: 6px;
}
.mb6 {
    margin-bottom: 6px;
}
.status-panel {
    overflow: hidden;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.panel-title {
    margin-bottom: 10px;
    font-weight: bold;
}
.control-grid {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
}
.control-grid + .control-grid {
    margin-top: 8px;
}
.control-btn {
    margin-left: 10px;
    padding: 6px 16px;
    flex-shrink: 0;
    white-space: nowrap;
}
.submit-btn {
    width: 100%;
    color: #fff;
    background-color: #ff761d;
}
.control-name {
    margin-bottom: 6px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #333333;
}
.control-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 13px;
    color: #999999;
}
</style>
